import { render, staticRenderFns } from "./FieldDateInput.vue?vue&type=template&id=3bdb65c6&scoped=true"
import script from "./FieldDateInput.vue?vue&type=script&lang=ts"
export * from "./FieldDateInput.vue?vue&type=script&lang=ts"
import style0 from "./FieldDateInput.vue?vue&type=style&index=0&id=3bdb65c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdb65c6",
  null
  
)

export default component.exports